export const TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY = Symbol('players-bonuse.create-manually');
export const PLAYERS_BONUS_CREATE_MANUALLY_ROUTE_NAME = Symbol('admin.players.bonuses.create.manually');

export const BONUS_MANUALLY_CREATE_MUTATION_KEY = Symbol('bonus-manually.create');
export const BONUS_MANUALLY_CREATE_API_URL = 'admin/bonuses';
